var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KSnackbar',{attrs:{"isOpen":true,"text":"This is a longer message demonstrating how the snackbar handles extended text","actionText":"Got it","duration":0}})
}
var staticRenderFns = []

export { render, staticRenderFns }